import AbstractKeys from '../all/AbstractKeys'

class KeplerKeys extends AbstractKeys {
    constructor() {
        super();
        this.keys = {
            UP: 38,
            DOWN: 40,
            LEFT: 37,
            RIGHT: 39,
            OK: 13,
            /**
             * Color keys
             */
            RED: 10001,
            GREEN: 10002,
            YELLOW: 10003,
            BLUE: 10004,

            /**
             * Content Playing keys
             */
            PLAY: 179,
            RWD: 227,
            FWD: 228,
            // PLAYPAUSE: 10252,
            // PREV_SKIP: 227, 
            // NEXT_SKIP: 228,

            BACK: 27, 
        };
    }
}

export default KeplerKeys;



// WEBPACK FOOTER //
// ./src/devices/kepler/Keys.js